import React from 'react';
import CurrencyFormat from 'react-currency-format';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import tw from 'twin.macro';

import { api } from '@/app/api';
import ProfileIcon from '@/assets/images/icons/ProfileIcon';
import { BigTitle, BodyText } from '@/components';

import MyDocumentsMobileHeader from './my-documents-mobile-header';

function MyDocumentsHeader({ mobile_phone, isMobile }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  return (
    <>
      {isMobile && <MyDocumentsMobileHeader mobile_phone={mobile_phone} />}
      <div tw='flex justify-between items-end'>
        <BigTitle text={t('my_cards.title')} twStyle={tw`sm:text-[50px] text-[32px]`} />
        {!isMobile && (
          <div tw='flex gap-2 mb-2 items-center'>
            <div tw='sm:w-[32px] sm:h-[32px] h-[28px] w-[28px] flex items-center justify-center bg-primary rounded-full'>
              <ProfileIcon />
            </div>

            <CurrencyFormat
              tw='whitespace-nowrap'
              value={mobile_phone}
              displayType={'text'}
              format='+# (###) ### ## ##'
            />
            <BodyText text={'•'} twStyle={tw`text-secondary`} />
            <button
              onClick={() => {
                navigate('/');
                dispatch(api.util.resetApiState());
              }}
            >
              <BodyText text={t('my_cards.exit')} twStyle={tw`cursor-pointer`} />
            </button>
          </div>
        )}
      </div>
    </>
  );
}

export default MyDocumentsHeader;
